module.exports = __webpack_public_path__ + "static/media/Thumb_1920x384_Lalela_v2.843cd146.jpg";